/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentProtocolEnum } from './ConversationalAgentProtocolEnum';
import {
  ConversationalAgentProtocolEnumFromJSON,
  ConversationalAgentProtocolEnumFromJSONTyped,
  ConversationalAgentProtocolEnumToJSON,
} from './ConversationalAgentProtocolEnum';

/**
 * Polymorphic serializer base class.
 *
 * Note that the discriminator field must exist at the same depth as the mapped
 * serializer fields for the OpenAPI introspection. See
 * https://swagger.io/docs/specification/data-models/inheritance-and-polymorphism/ for
 * more information. As such, it's not possible to define something like:
 *
 * {
 *     "object_type": "foo",
 *     "polymorphic_context": {
 *         <foo-specific fields>
 *     }
 * }
 *
 * without explicitly wrapping this in a parent serializer, i.e. -
 * ``polymorphic_context`` can not be a PolymorphicSerializer itself, as it requires
 * access to the ``object_type`` in the parent scope.
 * @export
 * @interface PatchedConversationalAgentInferencerPolymorphicShared
 */
export interface PatchedConversationalAgentInferencerPolymorphicShared {
  /**
   *
   * @type {ConversationalAgentProtocolEnum}
   * @memberof PatchedConversationalAgentInferencerPolymorphicShared
   */
  protocol?: ConversationalAgentProtocolEnum;
}

/**
 * Check if a given object implements the PatchedConversationalAgentInferencerPolymorphicShared interface.
 */
export function instanceOfPatchedConversationalAgentInferencerPolymorphicShared(
  value: object,
): value is PatchedConversationalAgentInferencerPolymorphicShared {
  return true;
}

export function PatchedConversationalAgentInferencerPolymorphicSharedFromJSON(
  json: any,
): PatchedConversationalAgentInferencerPolymorphicShared {
  return PatchedConversationalAgentInferencerPolymorphicSharedFromJSONTyped(json, false);
}

export function PatchedConversationalAgentInferencerPolymorphicSharedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedConversationalAgentInferencerPolymorphicShared {
  if (json == null) {
    return json;
  }
  return {
    protocol: json['protocol'] == null ? undefined : ConversationalAgentProtocolEnumFromJSON(json['protocol']),
  };
}

export function PatchedConversationalAgentInferencerPolymorphicSharedToJSON(
  value?: PatchedConversationalAgentInferencerPolymorphicShared | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: ConversationalAgentProtocolEnumToJSON(value['protocol']),
  };
}
